@let isUpdateLoading = agentsService.agentUpdateLoadingStatus() === LoadingState.LOADING;
@let isAgentByIdLoading = agentsService.agentByIdStatusLoadingStatus() === LoadingState.LOADING;
@let isAgentApproveLoading = agentsService.agentApproveLoadingStatus() === LoadingState.LOADING;

<div class="agent-modal">
  <h2 class="agent-modal__title">
    {{ 'monitoring.agents.modal.title' | translate }}
  </h2>

  <form
    class="agent-modal__form"
    [formGroup]="agentForm"
    (ngSubmit)="onSubmit()"
  >
    <lib-input
      class="agent-modal__field"
      formControlName="name"
      [libSkeleton]="isAgentByIdLoading"
      [disabled]="isAgentByIdLoading"
      [placeholder]="'monitoring.agents.modal.fields.name' | translate"
    />

    <mon-facility-select
      class="agent-modal__field"
      formControlName="facilityId"
      labelTranslateKey="monitoring.agents.filters.facility"
      [fullWidth]="true"
      [libSkeleton]="isAgentByIdLoading"
      [disabled]="isAgentByIdLoading"
    />

    <lib-input
      class="agent-modal__field"
      formControlName="comment"
      [libSkeleton]="isAgentByIdLoading"
      [disabled]="isAgentByIdLoading"
      [placeholder]="'monitoring.agents.modal.fields.comment' | translate"
    />

    <div class="agent-modal__actions">
      <lib-button
        buttonStyle="transparent-tertiary"
        type="button"
        [disabled]="isAgentByIdLoading"
        (click)="closeModal(false)"
      >
        {{ 'monitoring.agents.modal.actions.cancel' | translate }}
      </lib-button>

      <lib-button
        buttonStyle="primary"
        buttonType="submit"
        [disabled]="
          agentForm.invalid ||
          isUpdateLoading ||
          isAgentByIdLoading ||
          isAgentApproveLoading ||
          !canReadFacilities()
        "
      >
        {{ 'monitoring.agents.modal.actions.save' | translate }}
      </lib-button>
    </div>
  </form>
</div>
